export default {
  MODEL: "QmbDQfJQocLYoe6bZZuWEx3mMHrP1d4Z6kfLLCrNUPzavT",
};
